import './TabsWithAccordion.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { MAX_MOBILE_WIDTH } from '../../utils/constants';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { ReactComponent as IconChevronDown } from '../../resources/icons/IconChevronDown.svg';
import Spoiler from '../atoms/Spoiler/Spoiler';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { canUseDOM, get, getGlobalDictionaryTerm } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import { ReactComponent as ChevronDetLeftIcon } from '../../resources/icons/chevron-left-16-px.svg';
import { ReactComponent as ChevronDetRightIcon } from '../../resources/icons/chevron-right-16-px.svg';
const BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
const TabsWithAccordion = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const title = get(fields, 'data.item.title.jss', {
    value: ''
  });
  const subtitle = get(fields, 'data.item.subtitle.jss', {
    value: ''
  });
  const [selectedTab, setSelectedTab] = useState(0);
  const [allTabsIsClosed, setAllTabIsClosed] = useState(false);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary') || "#035E88";
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const filterAccordionItems = accordionItems => {
    return accordionItems.filter(el => el.title.jss.value && el.description.jss.value);
  };
  const tabs = get(fields, 'data.item.tabs', []).filter(el => el.title.jss.value && (el.description.jss.value || el.accordionItems && filterAccordionItems(el.accordionItems).length > 1));
  const onTabClick = step => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['tabClick'], params), tabs[step].title.jss.value);
    if (canUseDOM && window.innerWidth <= Number.parseInt(MAX_MOBILE_WIDTH) && !allTabsIsClosed && step === selectedTab) {
      setAllTabIsClosed(true);
    } else {
      setAllTabIsClosed(false);
    }
    setSelectedTab(step);
  };
  const renderAccordion = tab => {
    const items = tab.accordionItems && filterAccordionItems(tab.accordionItems);
    return /*#__PURE__*/React.createElement(React.Fragment, null, items && items.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: "accordion__spoilers-wrapper"
    }, items.map((el, i) => {
      const ctaLinkHref = get(el, 'ctaLink.jss.value.href', '');
      const ctaLinkTarget = get(el, 'ctaLink.jss.value.target', '');
      const icon = get(el, 'iconSvgCode.jss.value');
      const accordionTitle = el.title.jss.value;
      return /*#__PURE__*/React.createElement(Spoiler, {
        onToggle: val => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['accordionAction'], params), [tabs[selectedTab].title.jss.value, el.title.jss.value, val ? 'expand' : 'collapse']),
        key: i,
        title: /*#__PURE__*/React.createElement(React.Fragment, null, icon ? /*#__PURE__*/React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: icon
          },
          className: "spoiler__title-icon"
        }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("span", null, accordionTitle)),
        isDetSite: isDetSite,
        className: "accordion-inner-spoiler"
      }, /*#__PURE__*/React.createElement(RichText, {
        tag: "div",
        field: el.description.jss
      }), ctaLinkHref && /*#__PURE__*/React.createElement("a", {
        className: "accordion__cta",
        href: ctaLinkHref,
        target: ctaLinkTarget,
        onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['accordionAction'], params), [tabs[selectedTab].title.jss.value, el.title.jss.value, el.ctaLabel.jss.value])
      }, el.ctaLabel.jss.value, rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
        className: "btn-link__icon"
      }) : /*#__PURE__*/React.createElement(ChevronRight, {
        className: "btn-link__icon"
      })));
    })));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isGrey: params['Is Grey'] ? params['Is Grey'] === '1' : false,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isDetSite: isDetSite
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 accordion__main-title",
    field: title,
    "data-cy": "accordion-title"
  }), /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "accordion__main-description accordion__description",
    field: subtitle,
    "data-cy": "accordion-description"
  }), /*#__PURE__*/React.createElement("div", {
    className: `accordion ${allTabsIsClosed ? 'accordion--tabs-hidden-on-mobile' : ''}`,
    style: {
      gridTemplateRows: `repeat(${tabs.length}, minmax( ${isDetSite ? '5rem' : '6.625rem'}, auto)) auto`
    }
  }, tabs.length > 1 && tabs.map((tab, i) => {
    var _tab$image, _tab$image2;
    const ctaLinkHref = get(tab, 'ctaLink.jss.value.href', '');
    let ctaLinkTarget = get(tab, 'ctaLink.jss.value.target', '');
    const ctaLinkTitle = get(tab, 'ctaLink.jss.value.title', '');
    const ctaLeftIcon = get(tab, 'ctaLeftIcon.targetItem.svg.jss.value');
    const ctaRightIcon = get(tab, 'ctaRightIcon.targetItem.svg.jss.value');
    const ctaLabel = get(tab, 'ctaLabel.jss.value', '');
    const isTargetBlank = ctaLinkTarget === '_blank';
    if (ctaLinkTarget === '') {
      ctaLinkTarget = '_self';
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, /*#__PURE__*/React.createElement("button", {
      className: `accordion__tab ${i === selectedTab ? 'accordion__tab--selected-tab' : ''} ${i === selectedTab && !allTabsIsClosed ? 'accordion__tab--open' : ''}`,
      onClick: () => onTabClick(i),
      tabIndex: 0
    }, /*#__PURE__*/React.createElement("span", {
      className: "accordion__tab-title-content"
    }, /*#__PURE__*/React.createElement(Text, {
      field: tab.title.jss
    }), isDetSite ? /*#__PURE__*/React.createElement(ChevronDetRightIcon, {
      className: "accordion__chevron"
    }) : /*#__PURE__*/React.createElement(IconChevronDown, {
      className: "accordion__chevron"
    }))), i === selectedTab && /*#__PURE__*/React.createElement("div", {
      className: `accordion__content ${(_tab$image = tab.image) !== null && _tab$image !== void 0 && _tab$image.jss.value.src ? 'accordion__content--with-image' : 'accordion__content--without-image'}`,
      style: {
        gridRowEnd: tabs.length + 2
      }
    }, ((_tab$image2 = tab.image) === null || _tab$image2 === void 0 ? void 0 : _tab$image2.jss.value.src) && /*#__PURE__*/React.createElement("div", {
      className: "accordion__image",
      style: isDetSite ? {
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 xmlns:xlink=%22http://www.w3.org/1999/xlink%22 width=%2296%22 height=%2248%22 viewBox=%220 0 96 48%22 fill=%22none%22%3E%3Crect fill-opacity=%220.3%22 fill=%22url(%23pattern0_4286_59130)%22 height=%2248%22 width=%2296%22/%3E%3Cdefs%3E%3Cpattern id=%22pattern0_4286_59130%22 patternUnits=%22userSpaceOnUse%22 viewBox=%22-865 23724 24 48%22 width=%2248%22 height=%2248%22 x=%2248%22 patternContentUnits=%22objectBoundingBox%22%3E%3Cg id=%22pattern0_4286_59130_inner%22%3E%3Crect x=%22-888.5%22 y=%2223724.5%22 width=%2219%22 height=%2219%22 rx=%223.5%22 stroke=%22${String(primaryPageThemeColor).replace('#', '%23')}%22/%3E%3C/g%3E%3Cuse xlink:href=%22%23pattern0_4286_59130_inner%22 transform=%22translate(24 0)%22/%3E%3Cuse xlink:href=%22%23pattern0_4286_59130_inner%22 transform=%22translate(12 24)%22/%3E%3Cuse xlink:href=%22%23pattern0_4286_59130_inner%22 transform=%22translate(36 24)%22/%3E%3Cuse xlink:href=%22%23pattern0_4286_59130_inner%22 transform=%22translate(48 0)%22/%3E%3C/pattern%3E%3C/defs%3E%3C/svg%3E")`
      } : {}
    }, /*#__PURE__*/React.createElement("img", {
      src: BASE_URL ? `${BASE_URL}${tab.image.jss.value.src}&cw=600&ch=500` : tab.image.jss.value.src,
      alt: tab.image.jss.value.alt
    })), /*#__PURE__*/React.createElement("div", {
      className: "accordion__text-content"
    }, tab.title.jss.value && /*#__PURE__*/React.createElement("h1", {
      className: "accordion__title"
    }, tab.title.jss.value), /*#__PURE__*/React.createElement(RichText, {
      className: "accordion__description",
      tag: "div",
      field: {
        value: tab.description.jss.value
      }
    }), tab.ctaLink && ctaLinkHref && /*#__PURE__*/React.createElement("a", {
      onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaClick'], params), [tabs[selectedTab].title.jss.value, tab.ctaLabel ? tab.ctaLabel.jss.value : '']),
      className: "accordion__cta",
      href: ctaLinkHref,
      target: ctaLinkTarget,
      title: ctaLinkTitle
    }, Boolean(tab.ctaLeftIcon) && Boolean(tab.ctaRightIcon) ? /*#__PURE__*/React.createElement(React.Fragment, null, ctaLeftIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: ctaLeftIcon
      },
      className: "ctaLeftIcon"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null), tab.ctaLabel && tab.ctaLabel.jss.value, ctaRightIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: ctaRightIcon
      },
      className: "ctaRightIcon"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, tab.ctaLabel && tab.ctaLabel.jss.value, isDetSite ? rtl ? /*#__PURE__*/React.createElement(ChevronDetLeftIcon, {
      className: "btn-link__icon"
    }) : /*#__PURE__*/React.createElement(ChevronDetRightIcon, {
      className: "btn-link__icon"
    }) : rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
      className: "btn-link__icon"
    }) : /*#__PURE__*/React.createElement(ChevronRight, {
      className: "btn-link__icon"
    }))), renderAccordion(tab))));
  }))));
};
export default TabsWithAccordion;
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    isGrey,
    anchorUrlParameter,
    isDetSite
  } = _ref2;
  const commonStyles = isDetSite ? "croovjs" : "c18x6moe";
  const rtlStyles = isDetSite ? "ry4v9v9" : "r1logcgg";
  const ltrStyles = isDetSite ? "lt2x3h2" : "l17dop77";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${isGrey ? `${commonStyles}--grey` : ''} ${rtl ? rtlStyles : ltrStyles}`,
    anchorUrlParameter: anchorUrlParameter
  }, children);
};